// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__JKlPR","time":"index_time__Dugr9","timeIcon":"index_timeIcon__RHmL8"};